import React, { useContext } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ComponentContext from "../../contexts/ComponentContext";
import { useStores } from "../../contexts/StoreContext";
import Icon from "../../shared/Icon/Icon";
import Markdown from "../../shared/styles/Markdown";

const StyledSocialMediaLinks = styled.div`
  z-index: 2;

  a:last-child {
    margin-right: 0 !important;
  }
`;

function SocialMediaLinks(props) {
  const {
    mediaLinksWrapperClassName = "mb-4",
    iconClassName = "me-4",
    iconColor,
    iconSize,
  } = props;

  const { navigationStore } = useStores();
  const { socialmediaNavigation } = navigationStore;

  if (isEmpty(socialmediaNavigation)) {
    return null;
  }

  const { text } = useContext(ComponentContext);
  return (
    <StyledSocialMediaLinks className={mediaLinksWrapperClassName}>
      {text && <Markdown>{text}</Markdown>}
      <div className="d-flex align-items-center">
        {socialmediaNavigation.map((link) => (
          <a
            key={link.id}
            aria-label={link.title}
            className={iconClassName}
            data-testid={`${link.title}-icon`}
            href={link.externalPath}
            rel="noreferrer"
            target="_blank"
          >
            <Icon color={iconColor} icon={link.title} size={iconSize || 29} />
          </a>
        ))}
      </div>
    </StyledSocialMediaLinks>
  );
}

export default observer(SocialMediaLinks);

SocialMediaLinks.defaultProps = {
  iconClassName: "me-4",
  iconColor: "#000",
  iconSize: 29,
  mediaLinksWrapperClassName: "mb-4",
};

SocialMediaLinks.propTypes = {
  iconClassName: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.number,
  mediaLinksWrapperClassName: PropTypes.string,
};
